module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图_01.jpg?v=77d2c4f2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图_01.jpg
 ** module id = 58
 ** module chunks = 1 2
 **/